(function () {
  // Si ya estamos en /cart no hacemos nada
  if (window.location.pathname === '/cart') return;

  function isInDrawer(el) {
    if (!el) return false;
    return !!(
      el.closest('.cart-drawer') ||
      el.closest('.drawer') ||
      el.closest('#CartDrawer') ||
      el.closest('.quick-add-drawer') ||
      el.closest('[data-cart-drawer]')
    );
  }

  // 1) Intercepta el submit del form del drawer que intenta ir a checkout
  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form) return;

    if (form.matches('form[action="/cart"]') && isInDrawer(form)) {
      var submitter = ev.submitter || document.activeElement;
      if (submitter && submitter.name === 'checkout') {
        ev.preventDefault();
        ev.stopPropagation();
        ev.stopImmediatePropagation();
        window.location.href = '/cart';
      }
    }
  }, true);

  // 2) Fallback: intercepta clics en botones de checkout dentro del drawer
  document.addEventListener('click', function (ev) {
    var btn = ev.target && ev.target.closest('button[name="checkout"], [name="checkout"], a[href*="/checkout"]');
    if (btn && isInDrawer(btn)) {
      ev.preventDefault();
      ev.stopPropagation();
      ev.stopImmediatePropagation();
      window.location.href = '/cart';
    }
  }, true);

  // 3) (Opcional) Oculta los pagos acelerados dentro del drawer
  var style = document.createElement('style');
  style.textContent = `
    .cart-drawer .shopify-payment-button,
    .drawer .shopify-payment-button,
    #CartDrawer .shopify-payment-button,
    .quick-add-drawer .shopify-payment-button { display: none !important; }
  `;
  document.head.appendChild(style);
})();
